module.exports = __webpack_public_path__ + "static/media/Equal-Play-Study-EN.a1265bbe.pdf";